import { useState, useEffect } from 'react';
import { MenuSelect } from '../menu-select';
import type { Option } from '../menu-select';

const defaultOptions = [
  { id: null, label: 'None' },
  { id: 'channel', label: 'Channel' },
  { id: 'recruiter', label: 'Recruiter' },
  { id: 'school', label: 'School' },
  { id: 'source', label: 'Source' },
];

interface BreakdownByProps {
  prefix?: string;
  options: Option[];
  selected: Option;
  onChange: (option: Option) => void;
  isEditMode?: boolean;
  menuStyles?: any;
  isPortal?: boolean;
}

export const BreakdownBy = ({
  prefix = 'Breakdown by',
  options = defaultOptions,
  selected,
  onChange,
  isEditMode = false,
  menuStyles = {},
  isPortal = false,
}: BreakdownByProps) => {
  // Initialize with selected prop if available, otherwise fallback to first option
  const [currSelected, setSelected] = useState(() => {
    if (selected) {
      const foundSelected = options?.find(
        (option) => option.id === selected?.id
      );
      return foundSelected || options[0];
    }
    return options[0];
  });

  const onSelect = (option) => {
    setSelected(option);
    onChange(option);
  };

  useEffect(() => {
    if (selected) {
      const foundSelected = options?.find(
        (option) => option.id === selected?.id
      );
      setSelected(foundSelected);
    }
  }, [selected, prefix, currSelected, options]);

  return (
    <MenuSelect
      options={options}
      selected={currSelected}
      onSelect={onSelect}
      prefix={prefix}
      editMode={isEditMode}
      menuStyles={menuStyles}
      isPortal={isPortal}
      headerText={`Select default ${prefix?.toLowerCase()}`}
    />
  );
};
